import { CartForm } from './_form'
import { CartList } from './_list'
import { getCartItems } from './_service'
import { CartItem } from './types'

export class CartController {
  constructor() {
    const listContainer = document.querySelector(
      '[data-cart-list]'
    ) as HTMLElement
    const formContainer = document.querySelector(
      '[data-form="cart"]'
    ) as HTMLElement

    if (listContainer && formContainer) {
      let form: CartForm | null = null
      const list = new CartList(listContainer, (items: CartItem[]) => {
        this.updatePageState()
        form?.update(items)
      })

      form = new CartForm(formContainer, list)

      const orderId = new URLSearchParams(window.location.search).get('order')
      if (orderId) {
        form.confirmOrderPayment(orderId)
      }
    }

    this.updatePageState()
  }

  private updatePageState() {
    const cartItems = getCartItems()

    const cartEmptyElement = document.querySelector(
      '[data-cart-empty]'
    ) as HTMLElement
    const cartBodyElement = document.querySelector(
      '[data-cart-body]'
    ) as HTMLElement

    if (cartItems.length === 0) {
      cartEmptyElement.classList.remove('is-hidden')
      cartBodyElement.classList.add('is-hidden')

      window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      cartEmptyElement.classList.add('is-hidden')
      cartBodyElement.classList.remove('is-hidden')
    }

    this.updateCartCount(cartItems.length)
  }

  public updateCartCount(count: number) {
    const cartCountElement = document.querySelector(
      '[data-cart-count]'
    ) as HTMLElement
    if (cartCountElement) {
      cartCountElement.textContent = count.toString()
    }
  }
}
